<template>
  <div id="AppointmentCard" v-bind="e2eAppointmentAttributes">
    <div class="topRow">
      <div class="textColumn">
        <div v-if="item.serviceName" class="title">
          {{ item.serviceName }}
        </div>
        <div v-if="item.clinician && item.clinician.name" class="name">
          <span>{{ item.clinician.name }}</span>
        </div>
        <div v-if="appointmentTime" class="time">
          <i class="fa-solid fa-clock" aria-hidden="true"></i>
          <span>{{ appointmentTime }}</span>
          <button v-if="shouldShowTimezoneInfo" type="button" class="timezoneInfoButton"
            aria-label="Show appointment time information" @click.stop="openTimezoneInfoModal">
            <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <div class="dateColumn">
        <div class="day">{{ appointmentDay }}</div>
        <div class="month">{{ appointmentMonth }}</div>
      </div>
    </div>
    <div v-if="isAffiliate">
      <p class="appt-info">Appointemnt session details have been emailed to {{ $store.getters.user.user.email }}</p>
    </div>
    <div v-else-if="upcoming" class="pt-4">
      <div v-if="cancelMode" class="areYouSure">
        Are you sure you want to cancel your appointment?
      </div>
      <div v-if="!cancelMode" class="btnRow">
        <div class="joinBtn cardBtn" @click="joinAppointment(item)">
          Join
        </div>
        <div class="cancelBtn cardBtn" v-if="canCancel" @click="cancelMode = true">
          Cancel
        </div>
      </div>
      <div v-else class="cancelMode btnRow">
        <div class="cardBtn cancelBtn position-relative" @click="cancelBooking">
          <span v-if="cancellationInProgress" class="button-loading"></span>
          <span v-else>Yes, cancel</span>
        </div>
        <div class="cardBtn greenBtn" @click="cancelMode = false">Go back</div>
      </div>
    </div>
  </div>
</template>
<script>
import EventBus from "../helpers/eventbus";
import MeetingRoomModal from "./DMH/Booking/MeetingRoomModal.vue";
import AppointmentTimezoneInfoModal from "./DMH/Booking/AppointmentTimezoneInfoModal.vue";
import axios from "axios";
import config from "../config/constants";
import { getAppointmentTimeDisplay } from "@/utils/appointmentTimezone";

export default {
  props: ["item", "upcoming", "setCurrentBookingId"],
  name: "AppointmentCard",
  data() {
    return {
      cancelMode: false,
      cancellationInProgress: false
    };
  },
  computed: {
    bookingTimeDisplay() {
      return getAppointmentTimeDisplay(this.item);
    },
    canCancel() {
      return this.bookingTimeDisplay.canCancel;
    },
    isAffiliate() {
      return this.item.appointmentType.toLowerCase() === "affiliate";
    },
    appointmentTime() {
      const startTime = this.bookingTimeDisplay.localStartTime;
      const endTime = this.bookingTimeDisplay.localEndTime;

      if (!startTime || !endTime) {
        return "";
      }

      return `${startTime.format("HH:mm")} - ${endTime.format("HH:mm")}`;
    },
    appointmentDay() {
      return this.bookingTimeDisplay.localStartTime?.format("DD") || "";
    },
    appointmentMonth() {
      return this.bookingTimeDisplay.localStartTime?.format("MMM") || "";
    },
    shouldShowTimezoneInfo() {
      return this.bookingTimeDisplay.shouldShowTimezoneInfo;
    },
    e2eAppointmentAttributes() {
      if (process.env.VUE_APP_E2E !== "true") {
        return {};
      }

      return { "data-appointment-id": this.item.appointmentId };
    },
  },
  methods: {
    joinAppointment(booking) {
      if (this.item.appointmentType === 'Coaching') {
        this.$router.push("/session/tmh/" + booking.appointmentId);
      } else {
        this.setCurrentBookingId(booking.appointmentId)
        this.$router.push("/session/dmh/" + booking.appointmentId);
      }
      EventBus.$emit("closeSidebar");
    },
    openTimezoneInfoModal() {
      if (!this.bookingTimeDisplay.timezoneInfo) {
        return;
      }

      const content = this.$createElement(AppointmentTimezoneInfoModal, {
        props: { timezoneInfo: this.bookingTimeDisplay.timezoneInfo },
      });
      const skin = this.$store.getters.skin;
      let opts = {
        title: "Appointment timezone",
        hideHeader: true,
        hideFooter: true,
        modalClass: "coach_modal theme-" + skin,
        size: "md",
        buttonSize: "sm",
        centered: true,
        contentClass: "coach_modal",
        id: "appointment_timezone_modal",
      };
      return this.$bvModal.msgBoxOk(content, opts);
    },
    async cancelBooking() {
      if (this.cancellationInProgress) {
        return;
      }
      this.cancellationInProgress = true;
      const payload = {
        user_id: this.$store.getters.user_id,
        appointment_id: this.item?.appointmentId,
        appointment_type: this.item?.appointmentType?.toLowerCase(),
        tags: this.item?.clinician?.tags,
        message: "User cancelled the session"
      };
      if (this.item?.service_slug) {
        payload.service_slug = this.item.service_slug
      }
      if (this.item?.clinician?.name) {
        payload.clinician_name = this.item.clinician.name
      }
      const res = await axios.post(
        config.api_env +
        "/application/api/u/dmh/cancel-appointment",
        payload,
        config.options
      );
      this.cancellationInProgress = false;
      if (res.data.success) {
        EventBus.$emit("getAppointments");
      }
    },
  }
};
</script>
<style lang="less">
#AppointmentCard {
  width: 100%;
  color: #333333;
  background-color: #ffffff;
  border: 0;
  border-radius: 6px;
  box-shadow: 0px 2px 2px 0px #33333326;
  padding: 16px;

  .appt-info {
    color: #000;
    font-size: 1.6rem;
    text-align: center;
    font-family: "DMSans Bold" !important;
    line-height: normal;
    margin: 12px 0 0;
  }

  .topRow {
    display: grid;
    grid-template-columns: 4fr 1fr;

    .textColumn {
      color: #333333;

      .title {
        font-family: "DMSans Bold";
        font-size: 1.8rem;
      }

      .name {
        font-family: "DMSans";
        font-size: 1.6rem;
        margin-bottom: 8px;
      }

      .time {
        display: flex;
        align-items: center;
        font-family: "DMSans";
        font-size: 1.6rem;
        color: #333333;

        i {
          color: #333333;
          font-size: 1.6rem;
          margin-right: 4px;
        }

        .timezoneInfoButton {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin-left: 8px;
          padding: 0;
          border: 0;
          background: transparent;
          cursor: pointer;

          i {
            color: #8a8a8a;
            margin-right: 0;
          }
        }
      }
    }

    .dateColumn {
      padding-right: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #403d56;

      .day {
        font-family: "DMSans Bold";
        font-size: 5.6rem;
        line-height: 5rem;
      }

      .month {
        font-family: "DMSans Bold";
        font-size: 1.8rem;
      }
    }
  }

  .areYouSure {
    font-size: 1.8rem;
    line-height: 2rem;
    font-family: "DMSans Bold";
    margin-bottom: 12px;
  }

  .btnRow {
    display: flex;
    width: 100%;
    justify-content: space-between;
    gap: 8px;

    .cardBtn {
      width: 100%;
      padding: 12px 16px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 15px;
      font-family: "DMSans Bold";
      color: #fff;
      font-size: 1.6rem;
      cursor: pointer;
      border: 0;
      margin-right: 5px;
    }

    .joinBtn {
      color: white;
      background: #604bff;

      i {
        margin-right: 10px;
      }
    }

    .cancelBtn {
      background-color: #ef2a1d;
    }

    .greenBtn {
      background: #30de7a;
    }
  }

  .button-loading::after {
    content: "";
    position: absolute;
    width: 20px;
    height: 20px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    border: 4px solid transparent;
    border-radius: 50%;
    border-top-color: white;
    border-bottom-color: white;
    animation: button-loading-spinner 1s ease infinite;
  }
}
</style>
